import { updateSort } from '!/actions/creators';
import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { getLocale, addGAEventTracking, sendGAEvent } from '!/common/helpers';


const actions = { updateSort };
class SelectSort extends PureComponent {
  handleChange = ({ target }) => {
    const currentValue = target.value;
    this.props.updateSort(currentValue);

    sendGAEvent('Search', 'Sorting changed', currentValue);
  };

  render() {
    const { sorting } = this.props;

    return (
      <div className="search-layout__sort">
        <form action="/search" method="GET">
          <label>
            {getLocale('Sort')}:
            <select name="sort" onChange={this.handleChange} {...addGAEventTracking('Click', 'Search', 'Sorting')}>
              {sorting.map((option, index) => (
                <option key={index} value={option.value} defaultValue={option.default}>
                  {getLocale(option.label)}
                </option>
              ))}
            </select>
            <noscript>
              <button type="submit">submit</button>
            </noscript>
          </label>
        </form>
      </div>
    );
  }
}

function mapStateToProps({ sorting }) {
  return { sorting };
}

export default connect(
  mapStateToProps,
  actions
)(SelectSort);
